export default __webpack_public_path__ + "static/iconography-image-d-1b955b8912dc9aa5a7975cda950224b88f6c8ec8e641deb3db0fcf93a9305b77.png";